module.exports = __webpack_public_path__ + "syndication/Components/PersistentActions/twitter.803ad4feb4ebff03500645b220cdd4d6.svg";